import router from '@/router';
import store from '@/store';
import 'bootstrap/dist/js/bootstrap.min.js';
import { VueSweetalert2 } from '@/plugins/sweetalert2';
import http from '@/plugins/axios';
import VueTheMask from '@/plugins/vue-the-mask';

const services = {
  router,
  store,
};

export default {
  install(app) {
    // Configurar SweetAlert2
    app.use(VueSweetalert2);

    // Configurar HTTP
    app.config.globalProperties.$http = http;

    // Usar outros serviços
    for (const key in services) app.use(services[key]);
    app.use(VueTheMask);
  },
};
